import { prepareFormData } from '@/store/utils/formDataHelper';
import {  getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { IStoreReady } from '@/store/lib/storeSupport';
import { AccountHistory, DataEntity } from '@/entity/clients/Accounts/history.types';
@Module({
    namespaced: true,
    name: 'clientsAccountsHistory',
    store,
    dynamic: true,
})
class clientsAccountsHistoryModule extends VuexModule implements IStoreReady {
    items: AccountHistory | null = null;
    item: DataEntity | null = null;
    itemsLoaded = false;
    itemLoaded = false; //
    ready = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: AccountHistory; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const items = await store.$repository.clientsAccountHistory.fetchAll(prepareFormData(data));
        if (items) {
            itemsLoaded = true;
        }
        return { items, itemsLoaded };
    }
    @MutationAction 
    async fetchData(data: PaginationRequestType):Promise<{ item: DataEntity; itemLoaded: boolean }> {
        let itemLoaded = false;
        const item = await store.$repository.clientsAccountHistory.fetchData(data)
        if (item) {
            itemLoaded = true;
        }
        return { item, itemLoaded };
    }    
}
export const clientsAccountsHistoryStore = getModule(clientsAccountsHistoryModule)